class collectionJS  {
    constructor () {
        this.collectionTemp = document.querySelector("[data-collection-temp]");
        this.productCount();
            this.collectionTemp.querySelectorAll("[data-product-per-page]").forEach((ele)=>{
            ele.addEventListener('change',(event)=>{
                this.setProductsPerPage(event);
            })
          });
        this.checkpageStatus();
        this.collectionTemp.querySelector("[data-previous-button]").addEventListener('click',(event)=>{
            this.previousButton();
        });
        this.collectionTemp.querySelector("[data-next-button]").addEventListener('click',(event)=>{
            this.nextButton();
        });

        this.collectionTemp.querySelectorAll("[type='radio']").forEach(ele=>{
            ele.addEventListener("change",(event)=>{
                this.checkpageStatus();
            });
        })
    }
    productCount(){
        document.querySelectorAll(".items_9").forEach((i) => {
            if (i.checked) {
                document.querySelector("[data-colletion_9]").classList.remove("d-none");
                document.querySelector("[data-colletion_15]").classList.add("d-none");
                document.querySelector("[data-colletion_30]").classList.add("d-none");
            } 
        })
        document.querySelectorAll(".items_15").forEach((i) => {
            if (i.checked) {
                document.querySelector("[data-colletion_15]").classList.remove("d-none");
                document.querySelector("[data-colletion_9]").classList.add("d-none");
                document.querySelector("[data-colletion_30]").classList.add("d-none");
            } 
        })
        document.querySelectorAll(".items_30").forEach((i) => {
            if (i.checked) {
                document.querySelector("[data-colletion_30]").classList.remove("d-none");
                document.querySelector("[data-colletion_9]").classList.add("d-none");
                document.querySelector("[data-colletion_15]").classList.add("d-none");
            } 
        })

        setInterval(() => {
            document.querySelectorAll("[data-product-per-page]").forEach(ele=>{
                if(ele.checked == true){
                    let productCount = ele.getAttribute("data-product-per-page");
                    productCount = parseInt(productCount);
                    document.querySelectorAll("[procut-count-text]").forEach(currentEle=>{
                        let size = currentEle.getAttribute("collection-page-size");
                        size = parseInt(size);
                        if(size == productCount){
                            let nextURL = currentEle.getAttribute("next-url");
                            let previousURL = currentEle.getAttribute("previous-url");
                            if(nextURL == null || nextURL != " "){
                                document.querySelector("[data-next-button]").classList.remove("disabled");
                            }else{
                                document.querySelector("[data-next-button]").classList.add("disabled");
                            }
                            if(previousURL != null || previousURL != ""){
                                document.querySelector("[data-previous-button]").classList.remove("disabled");
                            }else{
                                document.querySelector("[data-previous-button]").classList.add("disabled");
                            }
                            let content = currentEle.innerHTML;
                            document.querySelectorAll("[data-product-count]").forEach(eleText=>{
                                eleText.innerHTML = content;
                            })
                        }
                    })
                }
            })
        }, 1000);
    }

    setProductsPerPage(event){
        let inputVal = event.currentTarget.value;
        document.querySelector("[upper-pagination]").classList.add("d-none");
        let flag = false;
        if(document.querySelectorAll("[check-pagination-exist]").length > 0){
            document.querySelectorAll("[check-pagination-exist]").forEach(ele=>{
                let paginationVal = ele.getAttribute("check-pagination-exist");
                if(paginationVal == inputVal)flag = true;
            })
        }
        if(flag == true) {
           if(document.querySelector("[upper-pagination]").classList.contains("d-none"))document.querySelector("[upper-pagination]").classList.remove("d-none")
        }
        document.querySelectorAll(".items_9").forEach((i) => {
            if (i.checked) {
                document.querySelector("[data-colletion_9]").classList.remove("d-none");
                document.querySelector("[data-colletion_15]").classList.add("d-none");
                document.querySelector("[data-colletion_30]").classList.add("d-none");
            } 
        })
        document.querySelectorAll(".items_15").forEach((i) => {
            if (i.checked) {
                document.querySelector("[data-colletion_15]").classList.remove("d-none");
                document.querySelector("[data-colletion_9]").classList.add("d-none");
                document.querySelector("[data-colletion_30]").classList.add("d-none");
            } 
        })
        document.querySelectorAll(".items_30").forEach((i) => {
            if (i.checked) {
                document.querySelector("[data-colletion_30]").classList.remove("d-none");
                document.querySelector("[data-colletion_9]").classList.add("d-none");
                document.querySelector("[data-colletion_15]").classList.add("d-none");
            } 
        })
    }

    previousButton(){
        if( document.querySelector("[previous_button] a").classList.contains("disabled") ){
            document.querySelector("[data-previous-button]").classList.add("disabled");
        }else{
            document.querySelector("[previous_button] a").click();
        }
        setTimeout(() => {
            document.querySelectorAll(".items_9").forEach((i) => {
                if (i.checked) {
                    document.querySelector("[data-colletion_9]").classList.remove("d-none");
                    document.querySelector("[data-colletion_15]").classList.add("d-none");
                    document.querySelector("[data-colletion_30]").classList.add("d-none");
                } 
            })
            document.querySelectorAll(".items_15").forEach((i) => {
                if (i.checked) {
                    document.querySelector("[data-colletion_15]").classList.remove("d-none");
                    document.querySelector("[data-colletion_9]").classList.add("d-none");
                    document.querySelector("[data-colletion_30]").classList.add("d-none");
                } 
            })
            document.querySelectorAll(".items_30").forEach((i) => {
                if (i.checked) {
                    document.querySelector("[data-colletion_30]").classList.remove("d-none");
                    document.querySelector("[data-colletion_9]").classList.add("d-none");
                    document.querySelector("[data-colletion_15]").classList.add("d-none");
                } 
            })
        }, 2000);
        this.checkpageStatus();
    }

    nextButton(){
        if( document.querySelector("[next_button] a").classList.contains("disabled") ){
            document.querySelector("[data-next-button]").classList.add("disabled");
        }else{
            document.querySelector("[next_button] a").click();
        }
        setTimeout(() => {
            document.querySelectorAll(".items_9").forEach((i) => {
                if (i.checked) {
                    document.querySelector("[data-colletion_9]").classList.remove("d-none");
                    document.querySelector("[data-colletion_15]").classList.add("d-none");
                    document.querySelector("[data-colletion_30]").classList.add("d-none");
                } 
            })
            document.querySelectorAll(".items_15").forEach((i) => {
                if (i.checked) {
                    document.querySelector("[data-colletion_15]").classList.remove("d-none");
                    document.querySelector("[data-colletion_9]").classList.add("d-none");
                    document.querySelector("[data-colletion_30]").classList.add("d-none");
                } 
            })
            document.querySelectorAll(".items_30").forEach((i) => {
                if (i.checked) {
                    document.querySelector("[data-colletion_30]").classList.remove("d-none");
                    document.querySelector("[data-colletion_9]").classList.add("d-none");
                    document.querySelector("[data-colletion_15]").classList.add("d-none");
                } 
            })
        }, 2000);

        this.checkpageStatus();
    }

    checkpageStatus(){
        setTimeout(() => {
            if(document.querySelector("[previous_button] a") != null && document.querySelector("[previous_button] a").classList.contains("disabled") ){
                document.querySelector("[data-previous-button]").classList.add("disabled");
            }else{
                document.querySelector("[data-previous-button]").classList.remove("disabled");
            }
            if( document.querySelectorAll("[check-pagination-exist]").length > 0 && document.querySelector("[next_button] a").classList.contains("disabled") ){
                document.querySelector("[data-next-button]").classList.add("disabled");
            }else{
                document.querySelector("[data-next-button]").classList.remove("disabled");
            }
        }, 1000);
        setTimeout(() => {
            if(document.querySelectorAll("[check-pagination-exist]").length > 0){
                document.querySelector("[upper-pagination]").classList.remove("d-none");
                }else{
                    document.querySelector("[upper-pagination]").classList.add("d-none");
                }
        }, 3000);
    }
}

window.onload = () => {
    typeof collectionJS !== 'undefined' && new collectionJS();
  }
  new collectionJS()